import './App.css';
import './LightTheme.css';
import Menu from './components/Menu';
import PageContent from './components/PageContent';
import { AuthProvider } from './components/AuthModule';
import { ThemeProvider } from './components/ThemeModule';
import { MusicPlayerProvider } from './components/MusicPlayerContext';
import { I18nProvider } from './i18n/I18nModule';
import LocaleSyncFromSettings from './components/LocaleSyncFromSettings';

/** True when this path is a full-page view with no menu (/chat or any /event/*). */
function isFullPageNoMenu(path) {
  if (path === '/chat' || path === '/chat/') return true;
  return path.startsWith('/event/');
}

/** /profiili/:displayName (not /profiili/:numericId) — avatar badge sits outside the circle; avoid overflow clipping. */
function isPublicProfileByDisplayNamePath(path) {
  const p = path || '/';
  return /^\/profiili\/(?!\d+\/?$)([^/]+)\/?$/.test(p);
}

/** Oma profiili: /profiili, /profiili/:userId — sama merkki kuin julkisella sivulla. */
function isOwnProfileSettingsPath(path) {
  const p = path || '/';
  return /^\/profiili\/?$/.test(p) || /^\/profiili\/\d+\/?$/.test(p);
}

function App() {
  const path = typeof window !== 'undefined' ? window.location.pathname : '';
  const hideMenu = isFullPageNoMenu(path);
  const profileBadgeOverflow =
    isPublicProfileByDisplayNamePath(path) || isOwnProfileSettingsPath(path);

  return (
    <ThemeProvider>
      <I18nProvider>
        <AuthProvider>
          <LocaleSyncFromSettings />
          <MusicPlayerProvider>
        <div className={`App${profileBadgeOverflow ? ' App--public-profile-overflow' : ''}`}>
          {!hideMenu && (
            <header>
              <Menu />
            </header>
          )}
          <PageContent />
        </div>
        </MusicPlayerProvider>
      </AuthProvider>
      </I18nProvider>
    </ThemeProvider>
  );
}

export default App;
